import { Facebook } from "lucide-react";
import { LogoMark } from "./Logo";
import { FACEBOOK_URL } from "../site";

export default function Footer() {
  return (
    <footer data-testid="footer" className="overflow-hidden bg-[#0B131E] pt-16">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col gap-10 border-b border-slate-800 pb-12 md:flex-row md:items-start md:justify-between">
          <div className="max-w-sm">
            <span className="flex items-center gap-2.5">
              <LogoMark className="h-9 w-9" />
              <span className="font-serif text-xl font-semibold tracking-tight text-white">
                Pure<span className="text-teal-400">Textiles</span>
              </span>
            </span>
            <p className="mt-4 text-sm leading-relaxed text-slate-400">
              Nettoyage textile professionnel à domicile. Canapés, matelas,
              moquettes et habitacles auto — l'exigence du propre, fibre par
              fibre.
            </p>
            <a
              href={FACEBOOK_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-facebook-link"
              className="mt-6 inline-flex items-center gap-2 rounded-full border border-slate-700 px-5 py-2.5 text-sm font-semibold text-slate-200 transition-all duration-200 hover:border-[#1877F2] hover:bg-[#1877F2] hover:text-white"
            >
              <Facebook className="h-4 w-4" />
              Suivez-nous sur Facebook
            </a>
          </div>

          <nav className="grid grid-cols-2 gap-10 sm:grid-cols-2">
            <div>
              <p className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">
                Navigation
              </p>
              <ul className="mt-4 space-y-2.5 text-sm">
                <li><a href="#services" className="text-slate-400 transition-colors hover:text-teal-300">Services</a></li>
                <li><a href="#tarifs" className="text-slate-400 transition-colors hover:text-teal-300">Tarifs</a></li>
                <li><a href="#methode" className="text-slate-400 transition-colors hover:text-teal-300">Notre méthode</a></li>
                <li><a href="#contact" className="text-slate-400 transition-colors hover:text-teal-300">Contact</a></li>
              </ul>
            </div>
            <div>
              <p className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-500">
                Prestations
              </p>
              <ul className="mt-4 space-y-2.5 text-sm">
                <li><a href="#tarifs" className="text-slate-400 transition-colors hover:text-teal-300">Canapés & fauteuils</a></li>
                <li><a href="#tarifs" className="text-slate-400 transition-colors hover:text-teal-300">Matelas & literie</a></li>
                <li><a href="#tarifs" className="text-slate-400 transition-colors hover:text-teal-300">Moquettes & auto</a></li>
                <li><a href="#tarifs" className="text-slate-400 transition-colors hover:text-teal-300">Entreprises</a></li>
              </ul>
            </div>
          </nav>
        </div>

        <p
          className="pointer-events-none mt-8 select-none text-center font-serif text-[15vw] font-semibold leading-none tracking-tight text-white/[0.04]"
          aria-hidden="true"
        >
          PURETEXTILES
        </p>

        <div className="flex flex-col items-center justify-between gap-3 border-t border-slate-800 py-6 text-xs text-slate-500 sm:flex-row">
          <p>© {new Date().getFullYear()} PureTextiles — Tous droits réservés.</p>
          <p>Nettoyage textile à domicile — injection-extraction</p>
        </div>
      </div>
    </footer>
  );
}
